<script setup lang="ts">
/***
 * template to show array of enums
 */
import { useI18n } from 'vue-i18n';

import type { PaginatedDataTableCellProps } from '@/components/paginated-datatable/templates/templateTypes';
import type { SimpleConnectV1Dto } from '@/openapi';
const { t } = useI18n();
const props = defineProps<PaginatedDataTableCellProps>();
</script>

<template>
  <div
    v-for="(arrayValue, arrayIndex) in props.cell as Array<SimpleConnectV1Dto>"
    :key="arrayIndex"
  >
    {{ arrayValue?.name ? t(`enums.${arrayValue?.name?.toUpperCase()}`) : '' }}
  </div>
</template>
